export const MAX_PER_PAGE = 10;
export const MAX_PAGINATION_LIMIT = 6;